var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newRuleStepDisplayData(data) {
    var instance = {
        __type: "RuleStepDisplayData:#DecisionsFramework.Design.Flow.Service",
        ExecutionNumber: 0,
        Order: 0,
        Id: null,
        ParentGroupId: null,
        StepType: 0 /* RuleStepType.Step */,
        AnchorInfo: null,
        ResolvedAnchorData: null,
        HasAnchor: false,
        HasConverterFlow: false,
        VerbInfo: null,
        HasVerb: false,
        ValueInfo: null,
        HasValue: false,
        ValidationIssues: null,
        HeaderActions: null,
        TrueActions: null,
        FalseActions: null,
        MissingDataActions: null,
        HasRuleResultInfo: false,
        StepResults: null,
        IsIgnored: false,
        ShowEvaluateWithNot: false,
        EvaluateWithNot: false,
        HasSpecifiedVerb: false,
        IsListStep: false,
        ListAllGroupId: null,
        IsEnumeratorChild: false,
        EditableDataType: null,
        EditableMappingType: null,
        EditableDataValue: null,
        SharedStepId: null,
        ColumnId: null
    };
    return __assign(__assign({}, instance), data);
}
export function isRuleStepDisplayData(object) {
    return object.__type === "RuleStepDisplayData:#DecisionsFramework.Design.Flow.Service";
}
